import { render, staticRenderFns } from "./NvBottomNav.vue?vue&type=template&id=26aedcca&scoped=true&"
import script from "./NvBottomNav.vue?vue&type=script&lang=js&"
export * from "./NvBottomNav.vue?vue&type=script&lang=js&"
import style0 from "./NvBottomNav.vue?vue&type=style&index=0&id=26aedcca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26aedcca",
  null
  
)

export default component.exports